import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  testimonialTypes: [],
  lastYearTestimonials: [],
  cachedLastYearTestimonialsDisplay: null,
  publicLYTestimonials: [],
  totalPagesTestimonials: null,
  totalItemsTestimonials: null
}

const getters = {
  testimonialTypesList: state => state.testimonialTypes,
  cachedTestimonialsDisplaySettings: state => state.cachedLastYearTestimonialsDisplay,
  lastYearTestimonialsList: state => state.lastYearTestimonials,
  totalPagesLYTestimonials: state => state.totalPagesTestimonials,
  totalItemsLYTestimonials: state => state.totalItemsTestimonials,
  getLastYearTestimonialById: state => id => state.publicLYTestimonials.find(testimonial => testimonial.id === id),
  getTestimonialTypeById: state => id => state.testimonialTypes.find(type => type.id === id),
  getLastYearTestimonialsByType: state => typeId => state.publicLYTestimonials.filter(testimonial => testimonial.testimonialTypeId === typeId)
}

const actions = {
  async fetchLastYearTestimonials ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.lastYearTestimonials.getLastYearTestimonials(payload))
      commit(types.SET_LAST_YEAR_TESTIMONIALS, data)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setTestimonialsDisplaySettings ({ commit }, data) {
    commit(types.SET_LAST_YEAR_TESTIMONIALS_DISPLAY, data)
  },
  async createLastYearTestimonials ({ commit }, testimonials) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.lastYearTestimonials.addLastYearTestimonial(), {...testimonials})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchPablicLYTestimonials ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.lastYearTestimonials.gePublictLastYearTestimonials())
      commit(types.SET_PUBLIC_LAST_YEAR_TESTIMONIALS, data)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateLastYearTestimonials ({ commit }, testimonials) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.lastYearTestimonials.updateLastYearTestimonial(), {...testimonials})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async changeLYTestimonialStatus ({ commit }, status) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.lastYearTestimonials.changeStatusLYTestimonial(), status)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial status was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial status wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeLastYearTestimonial ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.lastYearTestimonials.deleteLastYearTestimonial(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial was removed successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchlastYearTestimonialsByType ({ commit }, typeId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.lastYearTestimonials.getLastYearTestimonialsByType(typeId))
      return data
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchTestimonialTypes ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.lastYearTestimonials.getTestimonialTypes())
      commit(types.SET_TESTIMONIAL_TYPES, data)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addTestimonialTypes ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.lastYearTestimonials.addTestimonialTypes(), {...type})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial type was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial type wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateTestimonialTypes ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.lastYearTestimonials.updateTestimonialTypes(), {...type})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial type was edited successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial type wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeTestimonialTypes ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.lastYearTestimonials.removeTestimonialType(payload))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial type was removed successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial type wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateDisplaySettingsTestimonials ({ commit }, settings) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.lastYearTestimonials.updateDisplaySettingsTestimonials(), {
        metadata: {
          sections: [...settings]
        }
      })

      commit(types.CREATE_SUCCESS_MESSAGE, 'Testimonial type was edited successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Testimonial type wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_TESTIMONIAL_TYPES] (state, { testimonialTypes }) {
    state.testimonialTypes = [...testimonialTypes]
  },
  [types.SET_LAST_YEAR_TESTIMONIALS] (state, { testimonials, totalPages, totalItems }) {
    state.lastYearTestimonials = [...testimonials]
    state.totalPagesTestimonials = totalPages
    state.totalItemsTestimonials = totalItems
  },
  [types.SET_PUBLIC_LAST_YEAR_TESTIMONIALS] (state, { testimonials }) {
    state.publicLYTestimonials = testimonials
  },
  [types.SET_LAST_YEAR_TESTIMONIALS_DISPLAY] (state, data) {
    state.cachedLastYearTestimonialsDisplay = data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/lastYearTestimonials.js